import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'resource#title',
  type: 'edition',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      // {
      //   id: 'text-viewer',
      //   type: 'text-viewer',
      //   options: {
      //     searchId: 'xml_text',
      //   },
      // },
      
      {
        id: 'parallel-text-viewer',
        type: 'parallel-text-viewer',
        options: {
          searchId: 'xml_text',
          grid: {
            panels: [0],
          },
          libOptions: {
            grid: {
              disableAddColumn: true,
            },
          },
          panels:[
            {
              id: "facsimile",
              title: "Facsimile",
              enabled: true,
              type: 'facsimile',
              facsimile: {  
                uri: '',
                scans: [],
                enabled: true,
                options: {
                  height: '700px',
                  defaultZoomLevel: 0,
                  showNavigator: false,
                  showNavigationControl: true,
                  showHomeControl: true,
                  showRotationControl: false,
                  showFullPageControl: true,
                },
              },
            },
          ]
        },
      },
      {
        id: 'image-viewer',
        type: 'viewer',
        grid: 3,
        tools: true,
        title: 'resource#image-viewer',
      },
      {
        id: 'metadata',
        type: 'metadata',
        title: 'resource#metadata',
      },
      {
        id: 'collection-references',
        type: 'collection',
        grid: 3,
        title: 'resource#collection_references',
      },
      {
        id: 'collection-referencedBy',
        type: 'collection',
        grid: 3,
        title: 'resource#collection_referencedBy',
      },
      {
        id: 'collection-isPartOf',
        type: 'collection',
        grid: 3,
        title: 'resource#collection_isPartOf',
      },
      {
        id: 'collection-bibliography',
        type: 'collection',
        grid: 1,
        title: 'Bibliography',
        options: {
          classes: 'mr-item-preview-bibliography disable-link',
          itemPreview: {
            limit: 9999,
            striptags: false,
          },
        },
      },
    ],
  },
} as ConfigMurucaResourceLayout;
  